<template>
    <div class="card mt-3" style="margin-bottom:10px">
        <div class="card-body">
            <div class="row">
                <div class="col-12">
                    <div class="d-flex justify-content-between align-items-center mb-4">
                        <h2 class="text-center mb-0"
                            style="color: #0078be; border-bottom: 2px solid #0078be; padding-bottom: 10px; flex-grow: 1;">
                            TURNOS DE ATENCIÓN
                        </h2>
                        <button @click="refreshPacienteTv" class="btn btn-primary ms-3"
                            style="height: 40px; background: #eb1265!important;">
                            <i class="fas fa-sync-alt me-2"></i>Actualizar
                        </button>
                    </div>

                    <div class="turns-list">
                        <div v-for="(turno, index) in turnosOrdenados" :key="index" class="turn-card p-4 mb-3" :class="{
                            'current-turn': index === 0,
                            'attended-turn': turno.atendido,
                            'unique-specialty-turn': esUnicoPorEspecialidadYDoctor(turno)
                        }" :style="getTurnStyle(turno, index)">
                            <div class="row align-items-center">
                                <div class="col-2 text-center">
                                    <h2 class="mb-0" :style="getTextStyle(turno, index)">
                                        {{ turno.numero }}
                                    </h2>
                                </div>
                                <div class="col-5">
                                    <h3 class="mb-2" :style="getTextStyle(turno, index)">{{ turno.paciente }}</h3>
                                    <h4 class="mb-0" :style="getTextStyle(turno, index)">DR. {{ turno.doctor }}</h4>
                                </div>
                                <div class="col-5 text-end">
                                    <h3 class="mb-0" :style="getTextStyle(turno, index)">
                                        {{ turno.especialidad }}
                                    </h3>
                                    <p class="mb-0" :style="getTextStyle(turno, index)">{{ turno.fecha }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
/* eslint-disable */


export default {
    name: "Presentar-en-Tv",
    components: {

    },

    data() {
        return {
            loading: true,
            isMobile: this.$isMobile,
            tokenAuth: localStorage.getItem("tokenAuth"),
            nextTurns: [],            
            audioPlayer: null // Inicializamos como null para configurarlo después
        };
    },
    computed: {
        turnosOrdenados() {
            return [...this.nextTurns].sort((a, b) => {
                // Primero los no atendidos
                if (!a.atendido && b.atendido) return -1;
                if (a.atendido && !b.atendido) return 1;

                // Luego los turnos marcados (próximos a atender)
                const aEsProximo = this.esUnicoPorEspecialidadYDoctor(a); // Cambiado aquí
                const bEsProximo = this.esUnicoPorEspecialidadYDoctor(b); // Cambiado aquí

                if (aEsProximo && !bEsProximo) return -1;
                if (!aEsProximo && bEsProximo) return 1;

                // Si ambos son marcados o no marcados, ordenar por fecha
                if (aEsProximo === bEsProximo) {
                    return new Date(a.fecha) - new Date(b.fecha);
                }

                return 0;
            });
        }
    },
    watch: {},

    activated() {
        this.handleNewUpdateTv()
    },

    beforeUnmount() {        

        // Limpiamos el reproductor de audio cuando el componente se destruye
        if (this.audioPlayer) {
            this.audioPlayer.pause();
            this.audioPlayer.src = ''; // Liberamos el recurso
            this.audioPlayer = null;
        }

        // Dejar de escuchar el evento cuando el componente se desmonta
        this.$eventBus.off('new_insert', this.handleNewUpdateTv);

    },
    mounted() {

        // Inicializamos el reproductor de audio cuando el componente se monta
        this.audioPlayer = new Audio('/sounds/turn-sound.mp3');
        this.audioPlayer.preload = 'auto'; // Precargamos el archivo de audio

        // Escuchamos el evento "canplaythrough" para asegurarnos de que el audio esté listo
        this.audioPlayer.addEventListener('canplaythrough', () => {
            console.log('El archivo de audio está listo para ser reproducido.');
        });


        if (this.isMobile) {
            this.$eventBus.emit("activeShowMenu");
        }

        // Escuchar el evento global 'new_insert'
        this.$eventBus.on('new_insert', this.handleNewUpdateTv);




    },
    methods: {


        handleNewUpdateTv() {
            this.cargaDatosPacienteTv(); // Recargar los datos

        },

        reproducirAudio() {
            this.audioPlayer.currentTime = 0; // Reiniciar el audio al inicio
            this.audioPlayer.play().catch(error => {
                console.error('Error al reproducir el sonido:', error);
            });
        },

        cargaDatosPacienteTv() {
            // Guardar los turnos activos actuales antes de la actualización
            const turnosActivosAnteriores = this.nextTurns
                .filter(t => !t.atendido && this.esUnicoPorEspecialidadYDoctor(t))
                .map(t => t.cod_paciente);

            this.$https.post('/listar/getListarPacientesTv', {}, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": this.tokenAuth,
                }
            }).then(response => {
                if (response.data.code === 200) {

                    // Agrupar por especialidad y doctor, y ordenar por fecha
                    const turnosPorEspecialidadYDoctor = {};
                    response.data.datos.forEach(turno => {
                        const key = `${turno.name_especialidad}-${turno.doctor}`;
                        if (!turnosPorEspecialidadYDoctor[key]) {
                            turnosPorEspecialidadYDoctor[key] = [];
                        }
                        turnosPorEspecialidadYDoctor[key].push(turno);
                    });

                    // Procesar cada especialidad y doctor y asignar números
                    const turnosProcessed = [];
                    Object.keys(turnosPorEspecialidadYDoctor).forEach(key => {
                        // Ordenar turnos de esta especialidad y doctor por fecha
                        const turnosOrdenados = turnosPorEspecialidadYDoctor[key].sort(
                            (a, b) => new Date(a.date_at) - new Date(b.date_at)
                        );

                        // Asignar números consecutivos dentro de cada especialidad y doctor
                        turnosOrdenados.forEach((turno, index) => {
                            turnosProcessed.push({
                                numero: `A${String(index + 1).padStart(3, '0')}`,
                                paciente: turno.nombres_pacientes,
                                especialidad: turno.name_especialidad,
                                doctor: turno.doctor,
                                fecha: turno.date_at,
                                atendido: turno.estado === 'Atendido',
                                cod_paciente: turno.cod_paciente
                            });
                        });
                    });

                    this.nextTurns = turnosProcessed;

                    // Verificar si hay nuevos turnos activos después de actualizar
                    const nuevosTurnosActivos = turnosProcessed
                        .filter(t => !t.atendido && this.esUnicoPorEspecialidadYDoctor(t))
                        .map(t => t.cod_paciente);

                    // Reproducir el sonido solo si hay nuevos turnos activos
                    const hayNuevosTurnos = nuevosTurnosActivos.some(
                        cod => !turnosActivosAnteriores.includes(cod)
                    );

                    console.log('Hay nuevos turnos')

                    if (hayNuevosTurnos) {
                        console.log('Sii')
                        this.reproducirAudio();
                    }
                }
            }).catch(error => {
                console.error('Error al cargar los turnos:', error);
            });
        },

        esUnicoPorEspecialidadYDoctor(turno) {
            const turnosMismaEspecialidadYDoctor = this.nextTurns.filter(t =>
                t.especialidad === turno.especialidad &&
                t.doctor === turno.doctor &&
                !t.atendido
            );

            if (turnosMismaEspecialidadYDoctor.length === 1) {
                return true;
            }

            // Si hay más de un turno de la misma especialidad y doctor, verificar si este es el más próximo
            if (turnosMismaEspecialidadYDoctor.length > 1) {
                const fechasOrdenadas = [...turnosMismaEspecialidadYDoctor].sort((a, b) =>
                    new Date(a.fecha) - new Date(b.fecha)
                );
                // El primer turno (más antiguo) de cada especialidad y doctor debe ser el siguiente
                return fechasOrdenadas[0].cod_paciente === turno.cod_paciente;
            }
            return false;
        },

        getTurnStyle(turno, index) {
            if (turno.atendido) {
                return 'background-color: white; border: 2px solid #e9ecef; border-radius: 10px;';
            }
            if (this.esUnicoPorEspecialidadYDoctor(turno)) {
                return 'background-color: #0078be; color: white; border-radius: 15px;';
            }
            return 'background-color: #f8f9fa; border-radius: 10px; border-left: 5px solid #0078be;';
        },

        getTextStyle(turno, index) {
            if (turno.atendido) {
                return 'color: #6c757d;';
            }
            if (this.esUnicoPorEspecialidadYDoctor(turno)) {
                return 'color: white;';
            }
            return 'color: #0078be;';
        },

        refreshPacienteTv() {
            this.$https.post('/listar/getUpdateListaTv', {}, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": this.tokenAuth,
                }
            }).then(response => {
                if (response.data.code === 200) {

                    this.showOk('Turnos actualizados correctamente');
                }
            }).catch(error => {
                console.error('Error al cargar los turnos:', error);
            });
        },


    }

}



</script>


<style scoped>
/* Configuración base de las tarjetas - Ajusta margin-bottom para el espacio entre tarjetas */
.turn-card {
    transition: all 0.3s ease;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    margin-bottom: 0.5rem !important;
    /* 👈 Reduce este valor para menos espacio entre tarjetas */
}

.turn-card:hover {
    transform: translateX(5px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.current-turn,
.unique-specialty-turn {
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.current-turn:hover,
.unique-specialty-turn:hover {
    transform: translateY(-5px);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

.attended-turn {
    opacity: 0.7;
    background-color: white !important;
}

.attended-turn:hover {
    transform: none;
    box-shadow: none;
}

/* Ajustes para pantallas grandes - Reduce estos valores para tarjetas más pequeñas */
@media (min-width: 1920px) {
    h2 {
        font-size: 2rem;
        /* 👈 Tamaño del número de turno y título */
        margin-bottom: 0 !important;
    }

    h3 {
        font-size: 1.5rem;
        /* 👈 Tamaño del nombre del paciente y especialidad */
        margin-bottom: 0.3rem !important;
    }

    h4 {
        font-size: 1.2rem;
        /* 👈 Tamaño del nombre del doctor */
        margin-bottom: 0 !important;
    }

    .turn-card {
        padding: 1rem !important;
        /* 👈 Espacio interno de la tarjeta */
    }
}

/* Ajustes para pantallas medianas - Reduce estos valores para tarjetas más pequeñas */
@media (min-width: 1366px) and (max-width: 1919px) {
    h2 {
        font-size: 1.75rem;
        /* 👈 Tamaño del número de turno y título */
        margin-bottom: 0 !important;
    }

    h3 {
        font-size: 1.25rem;
        /* 👈 Tamaño del nombre del paciente y especialidad */
        margin-bottom: 0.3rem !important;
    }

    h4 {
        font-size: 1rem;
        /* 👈 Tamaño del nombre del doctor */
        margin-bottom: 0 !important;
    }

    .turn-card {
        padding: 0.75rem !important;
        /* 👈 Espacio interno de la tarjeta */
    }
}

/* Ajustes para pantallas pequeñas - Reduce estos valores para tarjetas más pequeñas */
@media (max-width: 1365px) {
    h2 {
        font-size: 1.5rem;
        /* 👈 Tamaño del número de turno y título */
        margin-bottom: 0 !important;
    }

    h3 {
        font-size: 1.1rem;
        /* 👈 Tamaño del nombre del paciente y especialidad */
        margin-bottom: 0.3rem !important;
    }

    h4 {
        font-size: 0.9rem;
        /* 👈 Tamaño del nombre del doctor */
        margin-bottom: 0 !important;
    }

    .turn-card {
        padding: 0.5rem !important;
        /* 👈 Espacio interno de la tarjeta */
    }
}

.turns-list {
    margin-top: 1rem;
    /* 👈 Espacio superior de la lista de turnos */
}

/* Ajuste para la fecha */
p {
    font-size: 0.9rem;
    /* 👈 Tamaño de la fecha */
    margin-bottom: 0;
}
</style>